import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NavItem from "./NavItem";
import "./nav.css";
import { useStateContext } from "../../Contexts/ContextProvider";
import TenantBadge from "../auth/TenantBadge";

const navItems = [
  { icon: "dashboard", hlink: "/dashboard", title: "Dashboard", section: "Workspace" },
  { icon: "home", hlink: "/conference", title: "Conferences", section: "Manage events" },
  { icon: "event", hlink: "/sessions", title: "Sessions", section: "Manage events" },
  { icon: "table_view", hlink: "/news", title: "News", section: "Manage events" },
  { icon: "receipt_long", hlink: "/Requests", title: "Requests", section: "People" },
  { icon: "groups", hlink: "/Attendants", title: "Attendees", section: "People" },
  { icon: "error", hlink: "/Decliends", title: "Declined", section: "People" },
  { icon: "group", hlink: "/Users", title: "Users", section: "People" },
  { icon: "support", hlink: "/Sponsers", title: "Sponsors", section: "People" },
  { icon: "headset_mic", hlink: "/speakers", title: "Speakers", section: "People" },
  { icon: "mail", hlink: "/contacts", title: "Mail", section: "People" },
  { icon: "logout", hlink: "/logout", title: "Log out", section: "Account" },
];

const SideBar = ({ isExpanded, isMobileOpen, onExpandedChange, onMobileClose }) => {
  const location = useLocation();
  const { tenant } = useStateContext();
  const showLabels = isExpanded || isMobileOpen;

  useEffect(() => {
    onMobileClose();
  }, [location.pathname, onMobileClose]);

  useEffect(() => {
    if (!isMobileOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onMobileClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isMobileOpen, onMobileClose]);

  return (
    <>
      <button
        type="button"
        className={`sidebar-backdrop ${isMobileOpen ? "is-visible" : ""}`}
        onClick={onMobileClose}
        aria-label="Close navigation"
        tabIndex={isMobileOpen ? 0 : -1}
      />
      <aside
        className={`sidebar-shell ${isExpanded ? "is-expanded" : "is-collapsed"} ${isMobileOpen ? "is-mobile-open" : ""}`}
        id="sidenav-main"
        aria-label="Main navigation"
      >
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <span className="sidebar-brand__icon" aria-hidden="true">V</span>
            {showLabels && <span className="sidebar-brand__name">Velorates</span>}
          </div>
          <button
            type="button"
            className="sidebar-toggle"
            onClick={() => onExpandedChange(!isExpanded)}
            aria-label={isExpanded ? "Collapse navigation" : "Expand navigation"}
            aria-expanded={isExpanded}
            title={isExpanded ? "Collapse navigation" : "Expand navigation"}
          >
            <i className="material-icons" aria-hidden="true">{isExpanded ? "chevron_left" : "chevron_right"}</i>
          </button>
          <button
            type="button"
            className="sidebar-mobile-close"
            onClick={onMobileClose}
            aria-label="Close navigation"
          >
            <i className="material-icons" aria-hidden="true">close</i>
          </button>
        </div>

        {showLabels && tenant && <div className="sidebar-tenant"><TenantBadge tenant={tenant} /></div>}

        <nav className="sidebar-navigation" aria-label="Workspace">
          {navItems.map((item, index) => {
            const previousItem = navItems[index - 1];
            const showSection = item.section !== previousItem?.section;

            return (
              <div className="sidebar-navigation__item" key={item.hlink}>
                {showLabels && showSection && (
                  <p className="sidebar-section-label">{item.section}</p>
                )}
                <NavItem
                  icon={item.icon}
                  hlink={item.hlink}
                  title={showLabels ? item.title : ""}
                  label={item.title}
                  onNavigate={onMobileClose}
                />
              </div>
            );
          })}
        </nav>
        {isMobileOpen && <span className="sidebar-mobile-hint">Event operations workspace</span>}
      </aside>
    </>
  );
};

export default SideBar;
